import React from 'react';
import { motion } from 'framer-motion';
import { RevealItem, revealContainer } from '../common/Reveal';
import { BlandFunnel } from './BlandFunnel';
import { BlandTrendChart } from './BlandTrendChart';
import { BlandRecentCalls } from './BlandRecentCalls';
import { BlandLoTable } from './BlandLoTable';
import type { BlandReportData } from '../../utils/bland';
interface BlandOverviewProps {
  report: BlandReportData;
  scopeLabel: string;
  chartTitle: string;
}
export function BlandOverview({
  report,
  scopeLabel,
  chartTitle
}: BlandOverviewProps) {
  return <>
      <RevealItem data-id="element-47" data-mp="21vajl7g00rga">
        <BlandFunnel funnel={report.funnel} scopeLabel={scopeLabel} data-id="element-48" data-mp="21usfjon3h8xt" />
      </RevealItem>

      <motion.div variants={revealContainer} className="mt-6 grid gap-6 xl:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]" data-id="element-49" data-mp="1wwh5pdwsuyfl">
        <RevealItem fill data-id="element-50" data-mp="4770cmjt2t3">
          <BlandTrendChart data={report.series} title={chartTitle} data-id="element-51" data-mp="3fa8yh7sz18" />
        </RevealItem>
        <RevealItem fill data-id="element-52" data-mp="3rbjmmn7s986w">
          <BlandRecentCalls data-id="element-53" data-mp="3r85kng3170zz" />
        </RevealItem>
      </motion.div>

      <RevealItem className="mt-6" data-id="element-54" data-mp="3ntkxglpev38e">
        <BlandLoTable rows={report.rows} title="Transfers by loan officer" data-id="element-55" data-mp="3nwp8o31amz8k" />
      </RevealItem>
    </>;
}